// extracted by mini-css-extract-plugin
export default {"frame":"ChallengeLoader_frame__3ins3","video":"ChallengeLoader_video__19MQ2","visible":"ChallengeLoader_visible__yLO7n","fallback":"ChallengeLoader_fallback__brUHp"};